module.exports = __webpack_public_path__ + "img/hanser.ce3d56bc.png";